/** Shared admin “new pending approval” badge (sidebar + Remedies tab). */
export const APPROVER_UNSEEN_KEY = 'meraayurved:admin-approver-unseen';
export const APPROVER_UNSEEN_CHANGED_EVENT =
  'meraayurved:approver-unseen-changed';

export function readApproverUnseen(): number {
  try {
    const raw = sessionStorage.getItem(APPROVER_UNSEEN_KEY);
    if (raw == null) return 0;
    const n = Number(raw);
    return Number.isFinite(n) && n > 0 ? Math.floor(n) : 0;
  } catch {
    return 0;
  }
}

export function writeApproverUnseen(count: number) {
  const next = Math.max(0, count);
  try {
    sessionStorage.setItem(APPROVER_UNSEEN_KEY, String(next));
  } catch {
    // ignore
  }
  window.dispatchEvent(
    new CustomEvent(APPROVER_UNSEEN_CHANGED_EVENT, { detail: { count: next } }),
  );
}

export function clearApproverUnseen() {
  writeApproverUnseen(0);
}

export function bumpApproverUnseen() {
  const next = readApproverUnseen() + 1;
  writeApproverUnseen(next);
  return next;
}
